export { getBaseUrl } from "../../../serverConfig";

export const decodeToken = (token: string) => {
    if (!token) {
        return;
    }

    try {
        const [headerEncoded, payloadEncoded] = token.split(".");

        const decodedHeader = Buffer.from(headerEncoded, "base64").toString(
                "utf-8"
            ),
            decodedPayload = Buffer.from(payloadEncoded, "base64").toString(
                "utf-8"
            );

        const header = JSON.parse(decodedHeader),
            payload = JSON.parse(decodedPayload);

        return { header, payload };
    } catch (error) {
        console.error("Error decoding idToken:", error);
    }
};
